<template>
  <div v-if="menuid" style="width: 38%; position: relative">
    <div
      ref="el"
      :style="'position: sticky; top:' + top + 'px; height: calc(100vh - ' + (top + bottom) + 'px); overflow: auto;'"
    >
      <div v-if="error" class="text-center m-5">
        <strong>Vorschau konnte nicht geladen werden.</strong><br />
        <p v-if="error.length" class="text-danger" v-html="error"></p>
        <p v-else>Bitte versuchen Sie es erneut.</p>
      </div>
      <template v-else>
        <template v-if="preview">
          <div v-if="sideBySideMode && menu.attributes.data.format == 'SP'" class="menu-grid">
            <img v-for="(img, index) in sortedPreviews(preview)" :key="index" :src="img" />
          </div>
          <div
            v-for="(img, index) in preview"
            v-else
            :key="index"
            class="text-center"
            :class="mode == 'width' ? 'w-100' : 'h-100'"
            :style="index == preview.length - 1 && 'margin-bottom: 0'"
          >
            <img :src="img" :class="mode == 'width' ? 'w-100' : 'h-100'" />
          </div>
        </template>
        <base-spinner v-else text="Lade Vorschau ..."></base-spinner
      ></template>
    </div>
    <div
      v-if="menu.errors?.pagecount"
      role="alert"
      class="alert m-5 alert-primary border-primary shadow position-fixed"
      :style="'top: ' + top + 'px; width: calc(38% - 6rem)'"
      v-html="menu.errors.pagecount[0]"
    ></div>
    <button
      v-if="preview && !sideBySideMode"
      class="btn btn-secondary rounded-circle text-white d-flex justify-content-center align-items-center position-fixed p-0"
      style="height: 2.5rem; width: 2.5rem; left: 1rem"
      :style="'bottom:' + (bottom + 16) + 'px'"
      @click="mode = mode == 'width' ? 'height' : 'width'"
    >
      <base-icon-fit-height v-if="mode == 'width'"></base-icon-fit-height>
      <base-icon-fit-width v-if="mode == 'height'"></base-icon-fit-width>
    </button>

    <button
      v-if="preview && menu.attributes.data.format == 'SP'"
      class="btn btn-secondary rounded-circle text-white d-flex justify-content-center align-items-center position-fixed p-0"
      style="height: 2.5rem; width: 2.5rem; left: 4.5rem"
      :style="'bottom:' + (bottom + 16) + 'px'"
      @click="sideBySideMode = !sideBySideMode"
    >
      <base-icon-six-pager></base-icon-six-pager>
    </button>

    <button
      class="btn btn-secondary position-fixed ps-5 rounded-pill text-nowrap text-white"
      style="margin: 0 auto; left: 19%; transform: translateX(-50%)"
      :style="'bottom:' + (bottom + 16) + 'px'"
      @click="reloadPdf"
    >
      <i class="bi bi-arrow-repeat position-absolute h4 lh-1 start-0 ms-2"></i>
      <span class="d-none d-lg-inline">Vorschau </span>aktualisieren
    </button>
    <div
      v-if="preview"
      class="btn-group-vertical position-fixed"
      style="left: calc(38% - 3.5rem)"
      :style="'bottom:' + (bottom + 16) + 'px'"
    >
      <button
        class="btn btn-secondary text-white d-flex justify-content-center align-items-center pb-1"
        :class="scrolltop && 'disabled'"
        style="height: 2rem; width: 2.5rem; border-top-left-radius: 50%; border-top-right-radius: 50%"
        @click="scrollByPage(-1)"
      >
        <i class="bi bi-arrow-up-short h4 lh-1 mb-0"></i>
      </button>
      <small class="bg-secondary text-white text-center py-1" style="width: 2.5rem">
        {{ currentPage }}/{{ pageCount }}
      </small>
      <button
        class="btn btn-secondary text-white d-flex justify-content-center align-items-center pt-1"
        :class="scrollbottom && 'disabled'"
        style="height: 2rem; width: 2.5rem; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%"
        @click="scrollByPage(1)"
      >
        <i class="bi bi-arrow-down-short h4 lh-1 mb-0"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref, toRefs, watch } from 'vue';

import { useScroll } from '@vueuse/core';

export default {
  props: {
    menuid: {
      type: String,
      default: null,
    },
    menu: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const el = ref('');
    const { arrivedState } = useScroll(el);
    const { top: scrolltop, bottom: scrollbottom } = toRefs(arrivedState);
    const preview = ref('');
    const error = ref(false);
    const currentPage = ref(1);
    const mode = ref('width');
    const pageCount = ref(0);
    const sideBySideMode = ref(false);

    const reloadPdf = () => {
      preview.value = '';
      error.value = false;
      window.axios
        .get('../../menu-pdf/' + props.menuid)
        .then((response) => {
          if (typeof response.data === 'string' && response.data.startsWith('Error: ')) {
            error.value = response.data.slice(7);
            return;
          }
          const ts = new Date().getTime();
          preview.value = response.data.map((img) => img + '?ts=' + ts);
          pageCount.value = response.data.length;
        })
        .catch(() => {
          error.value = true;
        });
    };
    const top = document.querySelector('header .curve').getBoundingClientRect().bottom + 56;
    const bottom = ref(0);
    const calcBottom = () => {
      bottom.value = Math.max(
        0,
        window.innerHeight - document.querySelector('.footer .curve').getBoundingClientRect().top + 36
      );
    };
    const onScroll = () => {
      if (!el.value.querySelector('img')) {
        return;
      }
      const imgHeight = el.value.querySelector('img').offsetHeight + 16;
      currentPage.value = Math.ceil((el.value.scrollTop + 0.00001) / imgHeight);
    };
    const scrollByPage = (direction) => {
      if (!el.value.querySelector('img')) {
        return;
      }
      const imgHeight = el.value.querySelector('img').offsetHeight + 16;
      const newY = imgHeight * (currentPage.value - 1) + imgHeight * direction;
      if ('scrollBehavior' in document.documentElement.style) {
        el.value.scrollTo({ top: newY, left: 0, behavior: 'smooth' });
      } else {
        el.value.scrollTo(0, newY);
      }
    };

    const sortedPreviews = (previews) => {
      return [previews[4], previews[5], previews[0], previews[1], previews[2], previews[3]];
    };

    watch(
      () => props.menu.attributes.layout_id,
      () => {
        setTimeout(() => {
          reloadPdf();
        }, 200);
      }
    );

    watch(
      () => props.menu.attributes.data.format,
      () => {
        if (props.menu.attributes.data.format != 'SP') {
          sideBySideMode.value = false;
        }
      },
    );

    watch(
      () => props.menu.attributes.format_id,
      () => {
        setTimeout(() => {
          reloadPdf();
        }, 200);
      },
    );

    onMounted(() => {
      reloadPdf();
      window.addEventListener('scroll', calcBottom);
      el.value.addEventListener('scroll', onScroll);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', calcBottom);
      el.value.removeEventListener('scroll', onScroll);
    });

    return {
      bottom,
      calcBottom,
      currentPage,
      el,
      error,
      mode,
      sideBySideMode,
      scrollByPage,
      pageCount,
      preview,
      reloadPdf,
      scrollbottom,
      scrolltop,
      top,
      sortedPreviews,
    };
  },
};
</script>

<style lang="scss" scoped>
.menu-grid {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  row-gap: 1rem;

  img {
    width: 100%;
    height: auto;
  }
}
</style>
